import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InspectorControls, RichText, useBlockProps } from '@wordpress/block-editor';
import { ToggleControl, PanelBody } from '@wordpress/components';
import { createBlock, getDefaultBlockName } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
export default function ReadMore(_ref) {
  let {
    attributes: {
      content,
      linkTarget
    },
    setAttributes,
    insertBlocksAfter
  } = _ref;
  const blockProps = useBlockProps();
  return createElement(Fragment, null, createElement(InspectorControls, null, createElement(PanelBody, {
    title: __('Link settings')
  }, createElement(ToggleControl, {
    label: __('Open in new tab'),
    onChange: value => setAttributes({
      linkTarget: value ? '_blank' : '_self'
    }),
    checked: linkTarget === '_blank'
  }))), createElement(RichText, _extends({
    tagName: "a",
    "aria-label": __('"Read more" link text'),
    placeholder: __('Read more'),
    value: content,
    onChange: newValue => setAttributes({
      content: newValue
    }),
    __unstableOnSplitAtEnd: () => insertBlocksAfter(createBlock(getDefaultBlockName())),
    withoutInteractiveFormatting: true
  }, blockProps)));
}
//# sourceMappingURL=edit.js.map